import React from 'react';
import {
  ArticleBulletList,
  ArticleParagraph,
  ArticleSection,
  ArticleTable,
} from './article-shared';

export const TherapyCptCodesArticle: React.FC = () => (
  <>
    <ArticleSection title="Overview">
      <ArticleParagraph>
        BetterHelp lets you submit notes using over 80 CPT codes. We&apos;ve made it easy for you to decide which one to use
        by taking the data you put into the notes to suggest codes as you fill it in.
      </ArticleParagraph>
      <ArticleParagraph>
        Current Procedural Terminology—or CPT codes—are a universal system that lets providers, insurance companies,
        hospitals, laboratories, accreditation companies, and other parts of the healthcare system communicate about
        services and procedures performed. We use these codes to submit claims on behalf of licensed providers like you
        for the services you perform.
      </ArticleParagraph>
      <ArticleParagraph>
        Submit CPT codes through Client Session Notes after each client session. The CPT code you use will vary based on
        the type of counseling you did and how long the session was.
      </ArticleParagraph>
      <ArticleParagraph>
        Payers and standard coding rules have the “final word” on codes used for a session. If a payer changes the codes
        used, partially denies a claim, or if a provider uses disallowed codes together, we may recoup the payout. We
        will always discuss this with you beforehand.
      </ArticleParagraph>
    </ArticleSection>

    <ArticleSection title="Typical CPT codes on BetterHelp">
      <ArticleTable
        headers={[ 'CPT Code', 'Service', 'Duration, in minutes' ]}
        rows={[
          [ '90791*', 'Psychiatric Diagnostic Evaluation by a licensed clinician', '60–90' ],
          [ '90832', 'Psychotherapy', '16–37' ],
          [ '90834', 'Psychotherapy', '38–52' ],
          [ '90837*', 'Psychotherapy', '53+' ],
          [ '90839', 'Psychotherapy for crisis', 'Billed for the first 60' ],
          [ '90840', 'Psychotherapy for crisis', 'Additional 30 after 90839' ],
          [ '90846', 'Family therapy without the client present', '26+' ],
          [ '90847', 'Family therapy with the client present', '26+' ],
        ]}
      />
    </ArticleSection>

    <ArticleSection title="Coding considerations">
      <ArticleParagraph>
        Certain scenarios may cause an insurance company to request to review treatment notes. You should always include
        medical necessity for continued care in your clinical notes, especially for:
      </ArticleParagraph>
      <ArticleBulletList
        items={[
          'Codes marked with an * in the table',
          'Crisis intervention',
          'Family or couples therapy',
          'Adjustment Disorder diagnoses',
          'Billing for 90791 or 90792 more than once every 6 months for the same client',
          'Meeting with the same client more than once a week',
        ]}
      />
    </ArticleSection>
  </>
);
